import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const CabinCrewIcon = (props: SvgIconProps) => (
  <SvgIcon width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
    <path
      d="M23.8587 34.0228C29.3941 34.0228 33.8814 29.5355 33.8814 24.0001C33.8814 18.4647 29.3941 13.9774 23.8587 13.9774C18.3233 13.9774 13.8359 18.4647 13.8359 24.0001C13.8359 29.5355 18.3233 34.0228 23.8587 34.0228Z"
      fill="none"
      stroke="black"
      strokeWidth="2.22727"
      strokeMiterlimit="10"
    />
    <path
      d="M9.25195 41.7749C10.8863 39.4492 13.0564 37.5509 15.5789 36.2405C18.1014 34.9301 20.9023 34.246 23.7448 34.246C26.5874 34.246 29.3883 34.9301 31.9108 36.2405C34.4333 37.5509 36.6034 39.4492 38.2377 41.7749"
      fill="none"
      stroke="black"
      strokeWidth="2.22727"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.8746 6.16298L9.81146 12.0087C8.86254 12.4334 8.86254 13.7804 9.81146 14.2051L22.8746 20.0508C23.4999 20.3307 24.2149 20.3307 24.8403 20.0508L37.9034 14.2051C38.8523 13.7804 38.8523 12.4334 37.9034 12.0087L24.8403 6.16298C24.2149 5.88313 23.4999 5.88313 22.8746 6.16298Z"
      fill="white"
      stroke="black"
      strokeWidth="2.22727"
    />
    <path
      d="M23.4824 12.3643L18.0716 17.548C17.8537 17.7567 17.7305 18.0455 17.7305 18.3472V24.5566"
      fill="none"
      stroke="black"
      strokeWidth="2.22727"
      strokeLinecap="round"
    />
  </SvgIcon>
);
